import styled, { css } from 'styled-components';
import { Text } from '@lmn/design-system';
import { ellipsisOneLine, ellipsisTwoLines, userSelectNone } from '../../../styles/mixins';
import { imageWidthCalcStyle, priceContainerWidthCalcStyle } from '../utils/styled';

export const DetailsContainer = styled.div<{ isOverlay?: boolean }>`
  width: 100%;
  background: white;
  display: grid;
  ${userSelectNone};

  ${({ isOverlay }) => {
    if (isOverlay) {
      return css`
        border-radius: 8px;

        @media (max-width: 767px) {
          width: calc(100% - 104px);
          display: flex;
          flex-direction: column;
        }
      `;
    }
    return css`
      border-radius: 0 0 8px 8px;

      @media (min-width: 768px) {
        display: flex;
        border-radius: 0 8px 8px 0;

        ${imageWidthCalcStyle};
      }
    `;
  }}
`;

export const DetailsInnerContainer = styled.div<{
  isOverlay: boolean;
  soldOut?: boolean;
  isLoading?: boolean;
  isWaiting?: boolean;
}>`
  padding: 12px 16px 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  min-width: 0;

  @media (min-width: 768px) {
    ${({ isOverlay, soldOut }) => !isOverlay && !soldOut && priceContainerWidthCalcStyle}
  }

  @media (max-width: 767px) {
    padding-bottom: 0;

    ${({ isOverlay }) =>
      isOverlay &&
      css`
        margin-bottom: 4px;
      `}
  }

  ${({ isOverlay }) =>
    isOverlay
      ? css`
          padding: 8px 12px 0;
        `
      : css`
          @media (min-width: 768px) {
            padding-top: 16px;
          }
        `}
`;

export const TopText = styled(Text)<{ $isHO?: boolean }>`
  display: flex;
  align-items: flex-start;

  ${({ $isHO }) =>
    $isHO
      ? css`
          margin-bottom: 8px;
        `
      : css`
          margin-bottom: 12px;

          @media (min-width: 768px) {
            margin-bottom: 8px;
          }
        `};

  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    margin-top: 2px;
  }
`;

export const HotelName = styled(Text)<{ $isOverlay?: boolean; $isTSH?: boolean }>`
  margin-bottom: 2px;

  @media (min-width: 768px) {
    margin-bottom: 4px;
  }

  ${({ $isOverlay, $isTSH }) => {
    if ($isTSH) {
      return css``;
    }

    if ($isOverlay) {
      return css`
        @media (min-width: 768px) {
          margin-bottom: 2px;
        }

        ${ellipsisOneLine};
        max-width: 100%;
      `;
    }

    return css`
      ${ellipsisTwoLines};
    `;
  }}
`;
